import { track } from "@amplitude/analytics-react-native";
import { useMemo } from "react";
import { amp } from "src/api/amplitude";
import PillButton from "src/components/PillButton";
import { ShareClipboardDataType, useShareClipboard } from "src/components/ShareMenu";
import config from "src/config";
import { useGatheringStore } from "src/contexts/GatheringContext";
import IconCheck from "src/icons/IconCheck";
import IconLink from "src/icons/IconLink";
import IconUsers from "src/icons/IconUsers";
import { paddingLarge } from "src/styles/spacing";
import SectionHeader from "./SectionHeader";

const ViewersHeader = () => {
	const refCode = useGatheringStore((state) => state.refCode);
	const shareData = useMemo<ShareClipboardDataType>(() => {
		return refCode
			? [
					{
						type: "Url",
						url: `${config.share.base}/album/${refCode}`,
					},
				]
			: [];
	}, [refCode]);
	const { copied, handlePress: handleCopyClipboard } = useShareClipboard(shareData, {
		prefetched: { current: {} },
	});
	return (
		<SectionHeader
			Icon={IconUsers}
			text="Joiners"
			action={
				<PillButton
					Icon={copied ? IconCheck : IconLink}
					onPress={() => {
						track(amp.gathering.viewersCopyInvite);
						handleCopyClipboard();
					}}
				></PillButton>
			}
			containerStyle={{
				marginBottom: paddingLarge,
			}}
		/>
	);
};
export default ViewersHeader;
